// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2yQmN","col":"Table_col__1r7vM","fulfillmentStatus":"Table_fulfillmentStatus__3VMCl","emailCol":"Table_emailCol__1Ey45"};